import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

// routes
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import PublicRoutes from './PublicRoutes';
import ErrorBoundary from './ErrorBoundary';
import Loadable from 'ui-component/Loadable';

const LandingPage = Loadable(lazy(() => import('views/pages/landing')));

const RootElement = () => {
  // If the app is accessed via the production app subdomain, redirect to login by default
  if (window.location.hostname.includes('app.fieldnavi.com')) {
    return <Navigate to="/login" replace />;
  }
  // Otherwise show the landing marketing page
  return <LandingPage />;
};

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    { path: '/', element: <RootElement />, errorElement: <ErrorBoundary /> },
    { ...PublicRoutes, errorElement: <ErrorBoundary /> },
    { ...LoginRoutes, errorElement: <ErrorBoundary /> },
    { ...MainRoutes, errorElement: <ErrorBoundary /> }
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
